import { UseCartResult } from 'hooks/useCart';
import { ActiveCartGiftWithPurchases } from 'types/cart';

import { SelectedItemType } from '../types';

export const handleAddItemsToCart = async (
  itemsToAdd: SelectedItemType[],
  addToCart: UseCartResult['addToCart'],
  giftWithPurchase?: ActiveCartGiftWithPurchases,
  showMiniCart?: boolean
) =>
  addToCart(
    itemsToAdd.map(item => ({
      productId: item.size!.productId,
      bonusItemId: giftWithPurchase!.id,
      quantity: item.quantity,
      swatch: item.color,
      masterId: item.id.split('_')[0],
    })),
    undefined, // unnecessary param at the moment
    showMiniCart
  );
